module.exports = "/_next/static/images/success-plus-graph-771e8e47942dbba357ca63d58eff5f10.png";